import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from "@angular/router";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  emailError = new FormControl('', [Validators.required, Validators.email]);
  errorMessage: string = "";
  error429Message: string = "";
  errorVisible: boolean = false;
  hide = true;
  userData: any;
  firstErrorTimestamp: number | null = null; //Primer error 429
  tiempoEsperaRecarga: number = 60000;
  token: any;
  respToken: any;

  signin: FormGroup;

  private loginSubscription: Subscription | undefined;
  private loginSubscriptionStaging: Subscription | undefined;
  private userSubscription: Subscription | undefined;
  private tokenSubscription: Subscription | undefined;

  constructor(private userService: UserService, private router: Router, private formBuilder: FormBuilder,
    private userDataService: UserDataService, private error429: Error429Service, private msalService: MsalService) {
    this.signin = this.formBuilder.group({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  get emailInput() {
    return this.signin.get('email');
  }
  get passwordInput() {
    return this.signin.get('password');
  }

  login() {
    this.errorVisible = false;
    /*let user = { 
      email: this.emailInput?.value, 
      password: this.passwordInput?.value 
    };*/
    const user = new FormData();
    user.append('email', this.emailInput?.value);
    user.append('password', this.passwordInput?.value);
    user.append('_token', this.token.csrf_token);
    this.loginSubscription = this.userService.login(user).subscribe({
      next: resp => {
        this.respToken = resp.access_token;
        this.error429.setError(false);
      }, error: err => {
        console.log("Error", err)
        if (err.status == 429) {
          this.error429Message = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
          const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
          if (storedTimestamp == null) {
            this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
            localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
          } else {
            this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
          }
          this.recargarPaginaDespuesDeTiempo();
        }
        if (err.status == 422 || err.status == 401) {
          if (this.emailInput?.value.trim() !== "" && this.passwordInput?.value.trim() !== "") {
            this.errorVisible = true;
            this.errorMessage = err.error.message;
          }
        } else if (err.status == 406) {
          this.errorVisible = true;
          this.errorMessage = err.error.message;
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: async () => {
        try {
          await this.userService.setLocalSessionToken(this.respToken);
          /*const decryptedToken = await this.userService.getLocalSessionToken();
          console.log("Decrypted: ", decryptedToken);*/
          this.userSubscription = this.userService.getUser().subscribe({
            next: resp => {
              this.userData = resp;
              delete this.userData.user_token;
              this.userDataService.setUserData(this.userData);
              this.router.navigateByUrl("/home/establecimientos");
              /*if(this.userData.pro_id === 4){
                this.router.navigateByUrl("/home/establecimientos");
              } else {
                this.router.navigateByUrl("/home");
              }*/
            }, error: err => {
              if (err.status == 429) {
                this.error429Message = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
                const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
                if (storedTimestamp == null) {
                  this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
                  localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
                } else {
                  this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
                }
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            }, complete: () => { }
          });
        } catch (error) {
          console.error("Error setting or decrypting token:", error);
        }
      }
    });
  }

  loginMicrosoft() {
    this.msalService.loginPopup({ scopes: ['openid', 'profile', 'email'], prompt: 'select_account' }).subscribe({
      next: (result) => {
        if (result.account) {
          this.msalService.instance.setActiveAccount(result.account);
          this.loginSubscription = this.userService.validateToken(result.idToken).subscribe({
            next: resp => {
              this.respToken = resp.access_token;
              this.error429.setError(false);
            }, error: err => {
              if (err.status == 429) {
                this.error429Message = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
                const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
                if (storedTimestamp == null) {
                  this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
                  localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
                } else {
                  this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
                }
                this.recargarPaginaDespuesDeTiempo();
              }
              if (err.status == 401) {
                this.errorVisible = true;
                this.errorMessage = "No se ha podido iniciar sesión. Inténtelo  de nuevo.";
              } else {
                this.errorMessage = err.error.message;
              }
            }, complete: async () => {
              try {
                await this.userService.setLocalSessionToken(this.respToken);
                /*const decryptedToken = await this.userService.getLocalSessionToken();
                console.log("Decrypted: ", decryptedToken);*/
                this.userSubscription = this.userService.getUser().subscribe({
                  next: resp => {
                    this.userData = resp;
                    delete this.userData.user_token;
                    this.userDataService.setUserData(this.userData);
                    this.router.navigateByUrl("/home/establecimientos");
                    /*if(this.userData.pro_id === 4){
                      this.router.navigateByUrl("/home/establecimientos");
                    } else {
                      this.router.navigateByUrl("/home");
                    }*/
                  }, error: err => {
                    if (err.status == 429) {
                      this.error429Message = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
                      const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
                      if (storedTimestamp == null) {
                        this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
                        localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
                      } else {
                        this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
                      }
                      this.recargarPaginaDespuesDeTiempo();
                    } else {
                      this.errorMessage = err.error.message;
                    }
                  }, complete: () => { }
                });
              } catch (error) {
                console.error("Error setting or decrypting token:", error);
              }
            }
          })
        }
      },
      error: (err) => {
        if (err.errorCode === 'user_cancelled') {
          // console.log('El usuario canceló el login.');
        } else {
          console.error('Error en login:', err);
          alert('Ocurrió un error al iniciar sesión con Microsoft. Inténtelo  de nuevo.');
        }
      },
    });
  }

  async ngOnInit(): Promise<void> {

    await this.msalService.instance.initialize();

    this.tokenSubscription = this.userService.getCsrfToken().subscribe({
      next: resp => {
        this.token = resp;
      }, error: err => {
        if (err.status == 429) {
          this.error429Message = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
          const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
          if (storedTimestamp == null) {
            this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
            localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
          } else {
            this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
          }
          this.recargarPaginaDespuesDeTiempo();
        }
      }, complete: () => { }
    });
  }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.loginSubscriptionStaging) {
      this.loginSubscriptionStaging.unsubscribe();
    }
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    if (this.firstErrorTimestamp !== null) {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - this.firstErrorTimestamp;
      const remainingTime = Math.max(this.tiempoEsperaRecarga - elapsedTime, 0);
      console.log(remainingTime);
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, remainingTime);
    } else {
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, this.tiempoEsperaRecarga);
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
      this.error429.setError(false);
    });
    localStorage.removeItem('firstErrorTimestamp');
  }

  getErrorMessageEmail() {
    if (this.emailError.hasError('required')) {
      return 'Debes ingresar un email';
    }
    return this.emailError.hasError('emailErro') ? 'Not a valid email' : '';
  }

  getErrorMessagePassword() {
    if (this.emailError.hasError('required')) {
      return 'Debes ingresar una contraseña';
    }
    return "";
  }
}
